import IClerk from "@/types/clerk";
import { ICommit } from "@/apps/merchant3/shared-models/ICommit";

const actions = {
  setClerk: ({ commit }: ICommit, payload: IClerk): void => {
    commit("SET_CLERK", payload);
  },
  setClerkJwt: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CLERK_JWT", payload);
  },
};

export default actions;
